import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LinkRef } from '@kion/data-models';

@Component({
  selector: 'kion-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {

  @Input() title: string;
  @Input() mode: 'primary' | 'feature' | 'highlighted' | 'discreet' | 'big' | 'back' | 'default' | 'linked-application' | 'small' = 'default';
  @Input() disabled: boolean;
  @Input() hidden: boolean;
  @Input() isLink: boolean;
  @Input() link: string | LinkRef;
  @Input() isLoading: boolean;
  @Input() showTextWhileLoading: boolean;
  @Input() project: 'LR' | 'FS' | 'Dematic' | string;

  @Output() clicked: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  constructor() { }

  //emit on click
  btnClicked(event: MouseEvent): void {
    this.clicked.emit(event);
  }
}
